var map = {
	"./404.png": 19,
	"./about-2-bg-cut.png": 46,
	"./about-2-bg.png": 21,
	"./about-2.jpg": 47,
	"./about-btc.jpg": 48,
	"./about.jpg": 22,
	"./banner-poster.jpg": 49,
	"./blog/01.jpg": 50,
	"./blog/Bitcoin-Accounting.png": 51,
	"./blog/LN-course-blog.png": 52,
	"./blog/bitcoin-vs-SWIFT.png": 53,
	"./blog/utxo-wallet.png": 54,
	"./brand-logo/01.png": 55,
	"./brand-logo/02.png": 56,
	"./brand-logo/03.png": 57,
	"./brand-logo/04.png": 58,
	"./brand-logo/05.png": 59,
	"./brand-logo/Blockstream_small.png": 60,
	"./brand-logo/bitgo-small.png": 61,
	"./brand-logo/btcpay-small.png": 62,
	"./brand-logo/kubernetes_small.png": 63,
	"./brand-logo/lnd-logo-small.png": 64,
	"./brand-logo/react-native-small.png": 65,
	"./brand-logo/rust_lang_small.png": 66,
	"./brand-logo/trezor-small.png": 67,
	"./demo-page/bootstrap.png": 68,
	"./demo-page/code.png": 69,
	"./demo-page/coming-soon.jpg": 70,
	"./demo-page/document.png": 71,
	"./demo-page/fontawesome.png": 72,
	"./demo-page/google-font.png": 73,
	"./demo-page/jquery.png": 74,
	"./demo-page/pages/about.jpg": 75,
	"./demo-page/pages/blog-details-sidebar.jpg": 76,
	"./demo-page/pages/blog-details.jpg": 77,
	"./demo-page/pages/blog-grid.jpg": 78,
	"./demo-page/pages/blog-l-g.jpg": 79,
	"./demo-page/pages/blog-l-l.jpg": 80,
	"./demo-page/pages/blog-l-r.jpg": 81,
	"./demo-page/pages/blog-r-g.jpg": 82,
	"./demo-page/pages/contact.jpg": 83,
	"./demo-page/pages/home-1.jpg": 84,
	"./demo-page/pages/home-2.jpg": 85,
	"./demo-page/pages/service-details.jpg": 86,
	"./demo-page/pages/service.jpg": 87,
	"./demo-page/pages/team-details.jpg": 88,
	"./demo-page/pages/team.jpg": 89,
	"./demo-page/react.svg": 90,
	"./demo-page/responsive.png": 91,
	"./demo-page/sass.png": 92,
	"./demo-page/slick.jpg": 93,
	"./demo-page/slider-bg.jpg": 94,
	"./demo-page/speed.png": 95,
	"./demo-page/support.png": 96,
	"./favicon.ico": 97,
	"./feature/01-team.png": 98,
	"./feature/01.png": 99,
	"./feature/02.png": 100,
	"./feature/03.png": 101,
	"./fun-fact-bg.jpg": 23,
	"./icons/cancel-white.png": 24,
	"./icons/cancel.png": 102,
	"./icons/coloredbg.png": 103,
	"./icons/loader.gif": 104,
	"./icons/quote.png": 105,
	"./logo-dark.png": 25,
	"./logo-white.png": 106,
	"./logo.png": 20,
	"./page-header-bk.jpg": 107,
	"./page-header.jpg": 14,
	"./service/01.jpg": 108,
	"./service/02.jpg": 109,
	"./service/03.jpg": 110,
	"./service/04.jpg": 111,
	"./service/05.jpg": 112,
	"./service/06.jpg": 113,
	"./service/Benefits-of-Using-a-Cold-Storage-Wallet-small.jpg": 114,
	"./service/ProcessAutomation-small-700x600.jpg": 115,
	"./service/bitcoin-wallet-small.jpg": 116,
	"./service/bitcoin-wallet.jpg": 117,
	"./service/cross-border-payment-lightning-network.jpg": 118,
	"./service/cyber-security-small.jpg": 119,
	"./service/details/01.jpg": 120,
	"./service/details/02.jpg": 121,
	"./service/details/03.jpg": 122,
	"./service/flow-diagram-processes-planning.jpg": 123,
	"./service/icon/analysis.png": 124,
	"./service/icon/research.png": 125,
	"./service/icon/strategy.png": 126,
	"./service/icon/track-record.png": 127,
	"./service/service-bg.jpg": 26,
	"./slider/01-meeting-smile.jpg": 128,
	"./slider/01-sillon-cut.jpg": 129,
	"./slider/01.gif": 130,
	"./slider/01.jpg": 131,
	"./slider/01.jpg.bkp": 132,
	"./slider/01.png-rocket": 133,
	"./slider/02.jpg": 134,
	"./slider/h-2-01.jpg": 135,
	"./slider/h-2-02.jpg": 136,
	"./team/01.jpg": 137,
	"./team/02.jpg": 138,
	"./team/03.jpg": 139,
	"./team/04.jpg": 140,
	"./team/05.jpg": 141,
	"./team/06.jpg": 142,
	"./team/ceo.png": 143,
	"./team/details/date-1.png": 144,
	"./team/details/date-2.png": 145,
	"./team/details/date-3.png": 146,
	"./team/h-2-01-bk.png": 147,
	"./team/h-2-01.png": 148,
	"./team/h-2-02.png": 149,
	"./team/h-2-03.png": 150,
	"./team/h-2-04.png": 151,
	"./team/team-arrow-1.png": 152,
	"./team/team-arrow.png": 153,
	"./team/team-bg-2-bk.jpg": 154,
	"./team/team-bg-2.jpg": 27,
	"./team/team-bg.jpg": 155,
	"./team/team-details.jpg": 156,
	"./testimonial/bg-dot.png": 157,
	"./testimonial/client-01.jpg": 158,
	"./testimonial/client-02.jpg": 159,
	"./testimonial/client-03.jpg": 160,
	"./testimonial/h-2-t-01.png": 161,
	"./testimonial/h-2-t-02.png": 162,
	"./testimonial/h-2-t-03.png": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;